import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import Strapline from 'Components/StaticPages/ProductPageComponents/Strapline/Strapline';

import LocalTexts from '../DiscoverMWMove.texts.json';

const LocalT = new MDText(LocalTexts);

export const StraplineSection: FC = () => (
	<Strapline
		stats={LocalTexts.strapline.stats.map((stat) => ({
			primary: `${LocalT.translate(stat.primary)}`,
			secondary: `${LocalT.translate(stat.secondary)}`,
		}))}
	/>
);
